import { Component, OnInit, ViewChild, Output, EventEmitter, ViewContainerRef, Input} from '@angular/core';
import { BaseComponent } from '../../Library/BaseComponent';
import { ActivatedRoute, Router } from '@angular/router';
import { MasterDataService } from '../../Services/MasterDataService';
import { ShiftSetUpService } from '../../Services/ShiftSetUpService';
import { LoginLogoutRequest, LogoutComplainRequest,LogoutWORequest, ShiftSetUpModel, ComplainRegister, WOSearch, WODefaultFilters } from '../../Models/RequestModels';
import { ManualAssign } from '../../Components/ManualAssign/ManualAssign';
import { EntityCodes, ShiftSetup_LogoutOptions, JobOperationActions, WorkOrderStatuses } from '../../Models/EnumModels';
import { NgbModal, ModalDismissReasons, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ComplainService } from '../../Services/ComplainService';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import * as _ from "lodash";
import { ModalDialogService, SimpleModalComponent } from 'ngx-modal-dialog';
import * as alasql from 'alasql';

@Component({
    selector: 'ShiftStaffInOut',
    templateUrl: './ShiftStaffInOut.html',
})

export class ShiftStaffInOut extends BaseComponent implements OnInit {
    @ViewChild('content') content;
    @ViewChild('manualAssign') manualAssign: ManualAssign;

    reqModel: any = {};
    reqWOModel: any = {};
    Model: Array<any>;
    WOModel: Array<any>;
    ModalRef: NgbModalRef;
    StaffDetails: any;
    ManualAssignCallIndex: number;
    ManualAssignCallType : string;
    LoginLogoutRequest: LoginLogoutRequest;
    LoginLogoutRequestLst: Array<LoginLogoutRequest>;
    AssignedToStaff: string;
    IsLoginAction: boolean;
    Staff_ManualAssignCall: number;
    DisableModalOpenEvent: boolean = false;
    _JobOperationActions = JobOperationActions;
    TabID: number = 1;
    HasMNTLicense : boolean = false;
    workOrderStatuses = WorkOrderStatuses;
    adhocAutoAssignment : boolean = true;
    // Open Jobs which are in MNT
    openJobNumbersFromMNT : number[] = []
    @Input() SectionSkillStaffData: any;
    @Input() StaffList: any;
    //@Input() DisplayMode: number = 1;
    @Output() StaffUpdated: EventEmitter<number> = new EventEmitter<number>();

    constructor(public translate: TranslateService, public toastr: ToastrService, public route: ActivatedRoute, public router: Router, public masterService: MasterDataService, protected modalService: NgbModal, protected shiftSetUpService: ShiftSetUpService, protected complainService: ComplainService, private modalDialogService: ModalDialogService, private viewContainer: ViewContainerRef) {
        super(translate, toastr, route, router, masterService);
    }

    ngOnInit(): void {
        if(this.masterService.CheckActiveLicence_Module(this.masterService.ActivePropertyID, 'KMT_CORE')){
            // Get MNT WO Data Data
            this.HasMNTLicense = true;
        }
    }

    Open(Staff: any, PropertyId: number, IsLoginAction: boolean) {
        if (this.DisableModalOpenEvent) return;
        this.DisableModalOpenEvent = true;
        this.StaffDetails = Staff;
        this.IsLoginAction = IsLoginAction;
        this.Model = [];
        this.WOModel = [];
        this.LoginLogoutRequestLst = [];
        //this.LoginLogoutRequest = new LoginLogoutRequest();
        this.reqModel.Properties = [];
        this.reqModel.AssignedTo = [];
        this.reqModel.Properties.push(PropertyId);

        if (Array.isArray(Staff)) {
            Staff.forEach((item) => {
                this.reqModel.AssignedTo.push(item.StaffId);
                this.SetLogoutRequestObj(item, PropertyId);
                this.LoginLogoutRequestLst.push(this.LoginLogoutRequest);
            })
        }
        else {
            this.reqModel.AssignedTo.push(Staff.StaffId);
            this.SetLogoutRequestObj(Staff, PropertyId);
            this.LoginLogoutRequestLst.push(this.LoginLogoutRequest);
            //this.CreateModel(Staff);
        }

        if (!IsLoginAction) {
            //if (this.DisplayMode == 1) {
                //let data = this.SectionSkillStaffData.filter(Section => {
                //    Section.Skills.some(Skill => (Skill.Staff.filter(item => item.IsLoggedIn == true).length == 1 && Skill.Staff.filter(item => item.StaffId == this.StaffDetails.StaffId)))
                //});
                //if (data.length > 0)
                //    this.OpenConfirmationModal();
                //else {
                    this.GetOpenCalls(() => {
                        if ((this.Model && this.Model.length > 0) || (this.WOModel && this.WOModel.length > 0)) {
                            this.ModalRef = this.modalService.open(this.content, { size: 'lg', centered: true, backdrop:'static' });
                        }
                        else {
                            this.ModalRef = this.modalService.open(this.content, { centered: true, backdrop:'static' });
                        }
                        //else window.location.href = '/Pages/UserLogout';
                        this.ModalRef.result.then((result) => {
                        }, (reason) => {
                            this.DisableModalOpenEvent = false;
                        });
                    })
                //}
                //let query = 'Select count(StaffId), SectionId From (Select Section.StaffId, Section.SectionId From ? Section Left Join ? Staff On Section.StaffId = Staff.StaffId Where Staff.IsLoggedIn = true) Group By SectionId Having count(StaffId) = 1';
                //let data = alasql(query, [this.SectionStaffMapping, this.StaffList]);
                //if (data.length > 0) {
                //    let query1 = 'Select * From ? S1 Inner Join ? S2 On S1.SectionId = S2.SectionId Where S1.StaffId = ?';
                //    let Staffdata = alasql(query1, [this.SectionStaffMapping, data, Staff.StaffId]);
                //    if (Staffdata.length > 0)
                //        this.OpenConfirmationModal();
                //    else {
                //        this.GetOpenCalls(() => {
                //            if (this.Model && this.Model.length > 0)
                //                this.ModalRef = this.modalService.open(this.content, { size: 'lg', centered: true });
                //            else this.ModalRef = this.modalService.open(this.content, { centered: true });
                //        });
                //    }
                //}
                //else {
                //    this.GetOpenCalls(() => {
                //        if (this.Model && this.Model.length > 0)
                //            this.ModalRef = this.modalService.open(this.content, { size: 'lg', centered: true });
                //        else this.ModalRef = this.modalService.open(this.content, { centered: true });
                //    });
                //}
            //}
            //else {
             //   this.GetOpenCalls(() => {
             //       if (this.Model && this.Model.length > 0)
             //           this.ModalRef = this.modalService.open(this.content, { size: 'lg', centered: true });
             //       else window.location.href = '/Pages/UserLogout';
             //   })
            //}
        }
        else {
            this.ModalRef = this.modalService.open(this.content, { centered: true, backdrop:'static'});
            this.ModalRef.result.then((result) => {
            }, (reason) => {
                this.DisableModalOpenEvent = false;
            });
        }

    }

    SetLogoutRequestObj(Staff, PropertyId) {
        this.LoginLogoutRequest = new LoginLogoutRequest();
        this.LoginLogoutRequest.StaffId = Staff.StaffId;
        this.LoginLogoutRequest.Properties = [];
        this.LoginLogoutRequest.Properties.push(PropertyId);
        this.LoginLogoutRequest.IsLogin = this.IsLoginAction;
        this.LoginLogoutRequest.logoutOptionComplain = [];
    }

    CreateModel(data, OpenCalls): void {
        let nObj: any = {};
        nObj.StaffId = data.StaffId;
        nObj.StaffName = data.Description;
        nObj.OpenCalls = _.cloneDeep(OpenCalls);
        let index = this.LoginLogoutRequestLst.findIndex(item => item.StaffId == data.StaffId);
        nObj.OpenCalls.forEach(row => {
            row.LogoutOption = ShiftSetup_LogoutOptions.NEXT_AVAILABLE_STAFF;
            if(this.openJobNumbersFromMNT.indexOf(row.ComplainId) != -1){
                // Disable the row as this job is from MNT
                row.WOFromServiceDisabled = true;
            }else{
                // Only send the Logout option to backend, if not from MNT
                let reqObj = new LogoutComplainRequest();
                reqObj.ComplainId = row.ComplainId;
                reqObj.LogoutOption = row.LogoutOption;
                this.LoginLogoutRequestLst[index].logoutOptionComplain.push(reqObj);
            }
        })
        this.Model.push(nObj);
    }

    CreateWOModel(data, OpenCalls): void {
        let nObj: any = {};
        nObj.StaffId = data.StaffId;
        nObj.StaffName = data.Description;
        nObj.OpenCalls = _.cloneDeep(OpenCalls);
        let index = this.LoginLogoutRequestLst.findIndex(item => item.StaffId == data.StaffId);
        nObj.OpenCalls.forEach(row => {
            row.LogoutOption = ShiftSetup_LogoutOptions.NEXT_AVAILABLE_STAFF;
            row.DescriptionName = this.masterService.GetDescription(row.PropertyId, row.CallDescriptionId)
            row.DisplayName = row.WorkOrderDisplayNum ? row.WorkOrderDisplayNum : row.WONumber;
            if(!row.DescriptionName) row.DescriptionName  = row.Name;
            row.LocationName = this.masterService.MasterData_GetMutli(row.PropertyId, row.LocationId, EntityCodes.Location, "");
            let Status = this.complainService.getWorkOrderStatuses().find((item) => {
                return item.Id == row.WorkOrderStatus;
            })
            if(Status && Status.Name){
                row.StatusName = Status.Name
                row.StatusId = Status.Id
                if(Status.Id === WorkOrderStatuses.Started){
                    // In Progress WO
                    row.LogoutOption = ShiftSetup_LogoutOptions.MANUAL_REASSIGN;
                }
            }
            if(row.JobId){
                // Form Service WO, So can not auto assign or manual assign with it
                // row.LogoutOption = ShiftSetup_LogoutOptions.NEXT_AVAILABLE_STAFF;
                row.WOFromServiceDisabled = true;
                // This Workorder has a job number
                this.openJobNumbersFromMNT.push(row.JobId)
            }else{
                if(this.adhocAutoAssignment === false){
                    // Only Manual assign will be an option if adhocAutoAssignment is false for that property
                    row.LogoutOption = ShiftSetup_LogoutOptions.MANUAL_REASSIGN;
                }
            }

                let reqObj = new LogoutWORequest();
                reqObj.WOId = row.WorkOrderId;
                reqObj.PropertyId = row.PropertyId;


                reqObj.LogoutOption = row.LogoutOption;
                if(this.LoginLogoutRequestLst[index].logoutOptionWO)
                    this.LoginLogoutRequestLst[index].logoutOptionWO.push(reqObj);
                else this.LoginLogoutRequestLst[index].logoutOptionWO = [reqObj]


        })
        this.WOModel.push(nObj);
    }

    IsLastLoggedInStaff(Staff) {
        let LoggedInStaff = Staff.filter(item => item.IsLoggedIn == true);
        if (LoggedInStaff.length == 1) {
            if (this.isArray(this.StaffDetails)) {
                if (this.StaffDetails.findIndex(item => item.StaffId == LoggedInStaff[0].StaffId) >= 0)
                    return true;
            }
            else {
                if (this.StaffDetails.StaffId == LoggedInStaff[0].StaffId)
                    return true;
            }
        }
        return false;
    }

    OpenConfirmationModal(): void {
        this.modalDialogService.openDialog(this.viewContainer, {
            title: 'Please Confirm',
            childComponent: SimpleModalComponent,
            data: {
                text: 'Staff being logged out is last in the allocated section. Are you sure you want to logout ' + this.StaffDetails.Description + '?'
            },
            actionButtons: [
                {
                    text: 'Yes',
                    buttonClass: 'btn btn-primary',
                    onAction: () => {
                        this.GetOpenCalls(() => {
                            if ((this.Model && this.Model.length > 0) || (this.WOModel && this.WOModel.length > 0))
                                this.ModalRef = this.modalService.open(this.content, { size: 'lg', centered: true, backdrop:'static' });
                            else this.LoginLogout();
                        });
                        return true;
                    }
                },
                {
                    text: 'No',
                    buttonClass: 'btn btn-secondary',
                    onAction: () => {
                        return true;
                    }
                },
            ]
        });
    }

    //Callback(): void {
    //    if (this.Model && this.Model.length > 0)
    //        this.ModalRef = this.modalService.open(this.content, { size: 'lg', centered: true });
    //    else if (this.SectionStaffMapping) this.LoginLogout();
    //    else this.ModalRef = this.modalService.open(this.content, { centered: true });
    //}

    GetOpenCalls(cb) {
        this.reqModel.AllPending = false,
        this.reqModel.OpenOnly = true;
        this.reqModel.StatusCode = "OPN";
        this.reqModel.PageSize = 10000;
        this.openJobNumbersFromMNT = [];
        this.complainService.Complain_Search(this.reqModel).then(data => {
            //this.Model = data.Result;
            if(!this.HasMNTLicense){
                this.CreateServiceModel(data)
                return cb()
            }
            let woReq : WOSearch = {
                StaffIds : this.reqModel.AssignedTo,
                PropertyIds : this.reqModel.Properties,
                WorkOrderStatus: WODefaultFilters.ACTIVE_WORKORDER_STATUSES, // except parked, closed, cancelled
                Source: WODefaultFilters.VALID_SOURCES, // except PMs
            }
            this.complainService.WO_Search(woReq).then(async wodata => {
                if (wodata && wodata.Result && wodata.Result.Result  && wodata.Result.Result.length > 0) {
                    let configData = await this.complainService.Property_Settings(this.reqModel.Properties[0])
                    if (configData && configData.data && configData.data.adhocAutoAssignment === false) {
                        // No Auto Assignment allowed for Adhoc
                        this.adhocAutoAssignment = false;
                    } else {
                        this.adhocAutoAssignment = true;
                    }
                    if (Array.isArray(this.StaffDetails)) {
                        this.StaffDetails.forEach((row, index) => {
                            let FilteredOpenCalls: Array<any> = _.cloneDeep(wodata.Result.Result.WorkOrders.filter(item => item.LeadStaffId == row.StaffId));
                            if (FilteredOpenCalls.length > 0)
                                this.CreateWOModel(row, FilteredOpenCalls);
                        });
                    }
                    else {
                        this.CreateWOModel(this.StaffDetails,  wodata.Result.Result[0].WorkOrders);
                    }
                }
                this.CreateServiceModel(data)
                cb();
            })

        })
    }

    CreateServiceModel(data){
        if (data.Result.length > 0) {
            this.TabID = 1;
            if (Array.isArray(this.StaffDetails)) {
                this.StaffDetails.forEach((row, index) => {
                    let FilteredOpenCalls: Array<any> = _.cloneDeep(data.Result.filter(item => item.AssignedTo == row.StaffId));
                    if (FilteredOpenCalls.length > 0)
                        this.CreateModel(row, FilteredOpenCalls);
                });
            }
            else {
                this.CreateModel(this.StaffDetails, data.Result);
            }
        }else this.TabID = 2;
    }

    async LoginLogout() {

        if(this.HasMNTLicense && this.LoginLogoutRequestLst && this.LoginLogoutRequestLst[0] && this.LoginLogoutRequestLst[0].logoutOptionWO && this.LoginLogoutRequestLst[0].logoutOptionWO.length){  
            let foundReqWithManualReassignAndNoTech = this.LoginLogoutRequestLst[0].logoutOptionWO.find((wo) => wo.LogoutOption === ShiftSetup_LogoutOptions.MANUAL_REASSIGN && !wo.AssignedTo);
            if(foundReqWithManualReassignAndNoTech){
                // Show Error
                this.GetMultilingualToast("ERR_SELECT_TECH_FOR_MANUAL", 'error');
                return;
            }
        }

        let req = _.cloneDeep(this.LoginLogoutRequestLst);
        delete req[0].logoutOptionWO;
        this.shiftSetUpService.LoginLogout(this.LoginLogoutRequestLst).then(async data => {
            if (data && data.HasError) {
                this.GetMultilingualToast(data.Errors[0].ErrorMessage, 'error');
            }
            if (data && data.Result) {

                if(this.HasMNTLicense && this.LoginLogoutRequestLst && this.LoginLogoutRequestLst[0] && this.LoginLogoutRequestLst[0].logoutOptionWO && this.LoginLogoutRequestLst[0].logoutOptionWO.length){
                    let req = this.LoginLogoutRequestLst[0].logoutOptionWO.map((wo) => {
                        return {
                            WorkOrderId : wo.WOId,
                            PropertyId : wo.PropertyId,
                            LogoutOption : wo.LogoutOption,
                            LeadStaffId : wo.AssignedTo
                        }
                    })
                    let resultWO = await this.shiftSetUpService.LoginLogoutWO(req);
                    if (resultWO && resultWO.HasError) {
                        this.GetMultilingualToast(resultWO.Errors[0].ErrorMessage, 'error');
                        return;
                    }
                }

                if(this.ModalRef)
                    this.ModalRef.close();
                this.StaffUpdated.emit(data.Result);
            }
        })
            


    }

    ReassignAction(StaffId: number, CallIndex: number, CallDetails: any): void {
        let index = this.LoginLogoutRequestLst.findIndex(item => item.StaffId == StaffId);
        // callDetails.LogoutOption would be string since its selected from <select>, converting to int:
        const selectedOption = (CallDetails.LogoutOption === undefined || CallDetails.LogoutOption === null)
            ? CallDetails.LogoutOption
            : +CallDetails.LogoutOption;

        let pointer;
        if(CallDetails.WorkOrderId){
            // From WO List Reassign
            this.LoginLogoutRequestLst[index].logoutOptionWO[CallIndex].LogoutOption = selectedOption;
            pointer = this.WOModel.findIndex(item => item.StaffId == StaffId);
        }else{
            this.LoginLogoutRequestLst[index].logoutOptionComplain[CallIndex].LogoutOption = selectedOption;
            pointer = this.Model.findIndex(item => item.StaffId == StaffId);
        }
        if (CallDetails.LogoutOption == ShiftSetup_LogoutOptions.MANUAL_REASSIGN) {
            this.ManualAssignCallIndex = CallIndex;
            this.Staff_ManualAssignCall = StaffId;
            this.manualAssign.RequestModel = new ComplainRegister();
            if(CallDetails.WorkOrderId){
                this.ManualAssignCallType = "WO";
                this.manualAssign.OpenForAssignment(null, this.WOModel[pointer].OpenCalls[CallIndex].LocationId, this.WOModel[pointer].OpenCalls[CallIndex].PropertyId, CallDetails);
            }
            else {
                this.ManualAssignCallType = "Job";
                this.manualAssign.OpenForAssignment(this.Model[pointer].OpenCalls[CallIndex].CallDescriptionsId, this.Model[pointer].OpenCalls[CallIndex].LocationId, this.Model[pointer].OpenCalls[CallIndex].PropertyId, CallDetails);
            }
        }
        else {
            if(CallDetails.WorkOrderId){
            this.WOModel[pointer].OpenCalls[CallIndex].AssignedToStaff = '';
            }else this.Model[pointer].OpenCalls[CallIndex].AssignedToStaff = '';
        }
    }

    onReassigned(AssignedTo: number): void {
        let index = this.LoginLogoutRequestLst.findIndex(item => item.StaffId == this.Staff_ManualAssignCall);
        if(this.ManualAssignCallType === "Job"){
            this.LoginLogoutRequestLst[index].logoutOptionComplain[this.ManualAssignCallIndex].AssignedTo = AssignedTo;
            let pointer = this.Model.findIndex(item => item.StaffId == this.Staff_ManualAssignCall);
            this.Model[pointer].OpenCalls[this.ManualAssignCallIndex].AssignedToStaff = this.masterService.MasterData_GetMutli(this.reqModel.Properties[0], AssignedTo, EntityCodes.Staff, "")
        }else{
            this.LoginLogoutRequestLst[index].logoutOptionWO[this.ManualAssignCallIndex].AssignedTo = AssignedTo;
            let pointer = this.WOModel.findIndex(item => item.StaffId == this.Staff_ManualAssignCall);
            this.WOModel[pointer].OpenCalls[this.ManualAssignCallIndex].AssignedToStaff = this.masterService.MasterData_GetMutli(this.reqModel.Properties[0], AssignedTo, EntityCodes.Staff, "")
            if(!AssignedTo){
                if(this.WOModel[pointer].OpenCalls[this.ManualAssignCallIndex].StatusId && this.WOModel[pointer].OpenCalls[this.ManualAssignCallIndex].StatusId != WorkOrderStatuses.Started )
                this.WOModel[pointer].OpenCalls[this.ManualAssignCallIndex].LogoutOption = ShiftSetup_LogoutOptions.NEXT_AVAILABLE_STAFF;
            }
        }
    }

    isArray(obj: any) {
        return Array.isArray(obj)
    }
}
